/**
 * Configuracion de opciones de filtros.
 * Order by y otros
 */
import React from 'react';
import SortUp from 'material-ui-icons/ArrowDropUp';
import SortDown from 'material-ui-icons/ArrowDropDown';
export const filtersOptions = [
    {
        label: 'COMMON.PRICE_ASC',
        sortOn:'price',
        sortBy: 'asc',
        icon: <SortUp />
    },
    {
        label: 'COMMON.PRICE_DESC',
        sortOn:'price',
        sortBy: 'desc',
        icon: <SortDown  />
    },
    {
        label: 'COMMON.NAME_ASC',
        sortOn:'name',
        sortBy: 'asc',
        icon: <SortUp />
    },
    {
        label: 'COMMON.NAME_DESC',
        sortOn:'name',
        sortBy: 'desc',
        icon: <SortDown  />
    },
    {
        label: 'COMMON.REC_HOTELS_ASC',
        sortOn:'default',
        sortBy: 'asc',
        icon: <SortDown  />
    }
];


// WEBPACK FOOTER //
// ./src/components/Results/data/filterOptions.js